// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteSharedWebAddressModel {
    static getAttributeTypeMap() {
        return SiteSharedWebAddressModel.attributeTypeMap;
    }
}
SiteSharedWebAddressModel.discriminator = undefined;
SiteSharedWebAddressModel.additionalProperties = false;
SiteSharedWebAddressModel.attributeTypeMap = [
    {
        "name": "webAddressId",
        "baseName": "webAddressId",
        "type": "number"
    },
    {
        "name": "webAddressType",
        "baseName": "webAddressType",
        "type": "ContactInfoPurposeType"
    },
    {
        "name": "url",
        "baseName": "url",
        "type": "string"
    },
];
//# sourceMappingURL=siteSharedWebAddressModel.js.map